import { IOdataField } from '../../IOdataField';

export abstract class OdataFieldTwoValueOperator implements IOdataField {
  private field: IOdataField;
  private field2: IOdataField;
  private operator: string;

  constructor(field: IOdataField, field2: IOdataField, operator: string) {
    this.field = field;
    this.field2 = field2;
    this.operator = operator;
  }

  toFieldString() {
    return `${this.operator}(${this.field.toFieldString()},${this.field2.toFieldString()})`;
  };
}
